import React, { Component } from 'react'
import Header from '../../../Components/header/index'
import Footer from '../../../Components/Footer/index'
import './index.scss'
import { useParams } from 'react-router-dom'

function titleName(id) {
  let titlename = ''
  if (id == 1) {
    titlename = '空气系统运行监测箱'
  } else if (id == 2) {
    titlename = '气体运行监测报警器'
  } else if (id == 3) {
    titlename = '真空系统运行监测箱'
  } else if (id == 4) {
    titlename = '低温储罐运行监测一体机'
  } else if (id == 5) {
    titlename = '壁挂式温湿度变送器'
  } else if (id == 6) {
    titlename = '高温温湿度'
  } else if (id == 7) {
    titlename = '低温储罐运行监测仪'
  } else if (id == 8) {
    titlename = '风道式温湿度传感器'
  } else if (id == 9) {
    titlename = '通用型压力变送器'
  } else if (id == 10) {
    titlename = '防爆型压力变送器'
  } else if (id == 11) {
    titlename = '气体汇流排运行监测箱'
  }

  document.title = titlename + '_北京锐控自动化科技有限公司'

  return titlename
}
export default function () {
  const { id } = useParams()

  return (
    <div style={{ background: '#f6f6f6' }}>
      <Header />
      <div className="hardwaretwo">
        <div className="hardwaretwo-title">
          当前位置： 首页 > 产品中心 >硬件产品><span style={{ color: '#2176D0' }}>{titleName(id)} </span>
        </div>
        {id == 1 && (
          <div className="hardwaretwo-content">
            <div className="hardwaretwo-content-item">
              <div className="hardwaretwo-content-item-imgbox">
                <img className="hardwaretwo-content-item-img" src={require('../../../image/空气系统运行监测箱.png')} />
              </div>

              <div className="hardwaretwo-content-item-title">获取完整产品规格书</div>
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的姓名" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的公司" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的电话" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的邮箱" />
              <button className="hardwaretwo-content-item-button">立即获取</button>
            </div>
            <div className="hardwaretwo-content-item">
              <div className="hardwaretwo-content-item-h1">空气系统运行监测箱</div>
              <div className="hardwaretwo-content-item-textitle">产品概述</div>
              <div className="hardwaretwo-content-item-textcontent">该设备通过底层传感器所采集传输的电流、电压、压力、温度、露点数据，可最多同时时监测三台空压机组设备的运行状态，具有数据本地显示和异常报警功能，通过预留的数字通讯传输接口和内置通讯模块，可实现远程监测和手机端监测。</div>
              <div className="hardwaretwo-content-item-textitle">产品特点</div>
              <div className="hardwaretwo-content-item-textcontent">
                • 集约化设计，实现多功能和场景应用<br></br>• 现场安装简单，新旧设备系统均可加装<br></br>• 电子数显屏，数值直观清晰<br></br>• 全金属外壳，牢固耐用
              </div>
              <div className="hardwaretwo-content-item-textitle">适用场合</div>
              <div className="hardwaretwo-content-item-textcontent">适用于对空压机组系统运行状态的实时监测。</div>
              <div className="hardwaretwo-content-item-textitle">产品参数</div>
              <div className="hardwaretwo-content-item-table">
                <div className="hardwaretwo-content-item-table-th">
                  <div className="hardwaretwo-content-item-table-th-item">箱体供电</div>
                  <div className="hardwaretwo-content-item-table-th-item">显示方式</div>
                  <div className="hardwaretwo-content-item-table-th-item">监测数据</div>
                  <div className="hardwaretwo-content-item-table-th-item">输入方式</div>
                  <div className="hardwaretwo-content-item-table-th-item">输出方式</div>
                  <div className="hardwaretwo-content-item-table-th-item">产品尺寸</div>
                </div>

                <div className="hardwaretwo-content-item-table-td">
                  <div className="hardwaretwo-content-item-table-td-item">24VDC</div>
                  <div className="hardwaretwo-content-item-table-td-item">10寸电子数显屏</div>
                  <div className="hardwaretwo-content-item-table-td-item">3套气源设备运行参数＋1路主管道数据（压力、露点）</div>
                  <div className="hardwaretwo-content-item-table-td-item">4-20mA. RS-485</div>
                  <div className="hardwaretwo-content-item-table-td-item">RS-485、用于远程通信</div>
                  <div className="hardwaretwo-content-item-table-td-item">400mm × 300mm × 150mm</div>
                </div>
              </div>
            </div>
          </div>
        )}
        {id == 2 && (
          <div className="hardwaretwo-content">
            <div className="hardwaretwo-content-item">
              <div className="hardwaretwo-content-item-imgbox">
                <img className="hardwaretwo-content-item-img" style={{ height: '11rem' }} src={require('../../../image/气体运行监测报警器.png')} />
              </div>

              <div className="hardwaretwo-content-item-title">获取完整产品规格书</div>
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的姓名" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的公司" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的电话" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的邮箱" />
              <button className="hardwaretwo-content-item-button">立即获取</button>
            </div>
            <div className="hardwaretwo-content-item">
              <div className="hardwaretwo-content-item-h1">气体运行监测报警器</div>
              <div className="hardwaretwo-content-item-textitle">产品概述</div>
              <div className="hardwaretwo-content-item-textcontent">该设备预装专业的气体运行监测软件，通过分析底层传感器、智能仪表所采集传输的压力、流量数据，实现对各路气体运行供应状态的实时监测和异常数据的预报警，具备历史数据和报警记录查询功能。预留数字通讯传输接口和内置通讯模块，可实现远程监测和手机端监测。</div>
              <div className="hardwaretwo-content-item-textitle">产品特点</div>
              <div className="hardwaretwo-content-item-textcontent">
                • 实时数据监测，集中显示<br></br>• 全触控面板，操作便捷<br></br>• 软件界面图形化设计，后台支持自定义设置<br></br>• 多种通信方式可选，灵活选择配置
              </div>
              <div className="hardwaretwo-content-item-textitle">适用场合</div>
              <div className="hardwaretwo-content-item-textcontent">适用于多路、多介质用气场景的气体供应运行监测场景。</div>
              <div className="hardwaretwo-content-item-textitle">产品参数</div>
              <div className="hardwaretwo-content-item-table">
                <div className="hardwaretwo-content-item-table-th">
                  <div className="hardwaretwo-content-item-table-th-item">供应电压</div>
                  <div className="hardwaretwo-content-item-table-th-item">触摸屏尺寸</div>
                  <div className="hardwaretwo-content-item-table-th-item">压力监测通道</div>
                  <div className="hardwaretwo-content-item-table-th-item">流量监测通道</div>
                  <div className="hardwaretwo-content-item-table-th-item">气体名称/标识色</div>
                  <div className="hardwaretwo-content-item-table-th-item">通讯方式</div>
                  <div className="hardwaretwo-content-item-table-th-item">输入方式</div>
                  <div className="hardwaretwo-content-item-table-th-item">输出方式</div>
                  <div className="hardwaretwo-content-item-table-th-item">远程监控</div>
                  <div className="hardwaretwo-content-item-table-th-item">联动报警</div>
                  <div className="hardwaretwo-content-item-table-th-item">安装方式</div>
                </div>
                <div className="hardwaretwo-content-item-table-td">
                  <div className="hardwaretwo-content-item-table-td-item">标准24VDC</div>
                  <div className="hardwaretwo-content-item-table-td-item">15.6寸</div>
                  <div className="hardwaretwo-content-item-table-td-item">1~6路</div>
                  <div className="hardwaretwo-content-item-table-td-item">1~6路</div>
                  <div className="hardwaretwo-content-item-table-td-item">自定义编辑设置</div>
                  <div className="hardwaretwo-content-item-table-td-item">KPa、MPa.Psi.Bar</div>
                  <div className="hardwaretwo-content-item-table-td-item"> 以太网、4G、LORA</div>
                  <div className="hardwaretwo-content-item-table-td-item"> 4-20mA. RS485</div>
                  <div className="hardwaretwo-content-item-table-td-item"> 支持PC端、移动端远程监控</div>
                  <div className="hardwaretwo-content-item-table-td-item">支持</div>
                  <div className="hardwaretwo-content-item-table-td-item"> 壁挂式、嵌入式</div>
                </div>
              </div>
            </div>
          </div>
        )}

        {id == 3 && (
          <div className="hardwaretwo-content">
            <div className="hardwaretwo-content-item">
              <div className="hardwaretwo-content-item-imgbox">
                <img className="hardwaretwo-content-item-img" src={require('../../../image/真空系统运行监测箱.png')} />
              </div>

              <div className="hardwaretwo-content-item-title">获取完整产品规格书</div>
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的姓名" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的公司" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的电话" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的邮箱" />
              <button className="hardwaretwo-content-item-button">立即获取</button>
            </div>
            <div className="hardwaretwo-content-item">
              <div className="hardwaretwo-content-item-h1">真空系统运行监测箱</div>
              <div className="hardwaretwo-content-item-textitle">产品概述</div>
              <div className="hardwaretwo-content-item-textcontent">该设备通过底层传感器所采集传输的电流、电压、压力、温度数据，可最多同时监测三台真空机组设备的运行状态，具有数据本地显示和异常报警功能，通过预留的数字通讯传输接口和内置通讯模块，可实现远程监测和手机端监测。</div>
              <div className="hardwaretwo-content-item-textitle">产品特点</div>
              <div className="hardwaretwo-content-item-textcontent">
                • 多项数值集中显示<br></br>• 安装便捷，适配性强<br></br>• 电子数显，清晰明了<br></br>• 金属壳体，安全坚固
              </div>
              <div className="hardwaretwo-content-item-textitle">适用场合</div>
              <div className="hardwaretwo-content-item-textcontent">适用于对真空机组系统运行状态的实时监测。</div>
              <div className="hardwaretwo-content-item-textitle">产品参数</div>
              <div className="hardwaretwo-content-item-table">
                <div className="hardwaretwo-content-item-table-th">
                  <div className="hardwaretwo-content-item-table-th-item">箱体供电</div>
                  <div className="hardwaretwo-content-item-table-th-item">显示方式</div>
                  <div className="hardwaretwo-content-item-table-th-item">监测数据</div>
                  <div className="hardwaretwo-content-item-table-th-item">输入方式</div>
                  <div className="hardwaretwo-content-item-table-th-item">输出方式</div>
                  <div className="hardwaretwo-content-item-table-th-item">产品尺寸</div>
                </div>

                <div className="hardwaretwo-content-item-table-td">
                  <div className="hardwaretwo-content-item-table-td-item">24VDC</div>
                  <div className="hardwaretwo-content-item-table-td-item">10寸电子数显屏</div>
                  <div className="hardwaretwo-content-item-table-td-item">3套气源设备运行参数+1路主管道数据（压力）</div>
                  <div className="hardwaretwo-content-item-table-td-item">4-20mA. RS-485</div>
                  <div className="hardwaretwo-content-item-table-td-item">RS-485、用于远程通信</div>
                  <div className="hardwaretwo-content-item-table-td-item">400mm × 300mm X150mm</div>
                </div>
              </div>
            </div>
          </div>
        )}
        {id == 4 && (
          <div className="hardwaretwo-content">
            <div className="hardwaretwo-content-item">
              <div className="hardwaretwo-content-item-imgbox">
                <img className="hardwaretwo-content-item-img" style={{ width: '8rem' }} src={require('../../../image/低温储蓄罐.png')} />
              </div>

              <div className="hardwaretwo-content-item-title">获取完整产品规格书</div>
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的姓名" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的公司" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的电话" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的邮箱" />
              <button className="hardwaretwo-content-item-button">立即获取</button>
            </div>
            <div className="hardwaretwo-content-item">
              <div className="hardwaretwo-content-item-h1">低温储罐运行监测一体机</div>
              <div className="hardwaretwo-content-item-textitle">产品概述</div>
              <div className="hardwaretwo-content-item-textcontent">该设备预装专业的低温储罐供气系统监测软件，通过分析底层传感器、智能仪表所采集传输的数据，实现对系统运行状态远程实时监测和异常状态的预报警，具备历史数据和报警记录查询功能。</div>
              <div className="hardwaretwo-content-item-textitle">产品特点</div>
              <div className="hardwaretwo-content-item-textcontent">
                • 实时数据监测，有效保障系统安全运行<br></br>• 高频率数据采集，避免异常数据丢失<br></br>• 软件界面图形化设计，操作便捷<br></br>• 数据传输方式多样，灵活选择
              </div>
              <div className="hardwaretwo-content-item-textitle">适用场合</div>
              <div className="hardwaretwo-content-item-textcontent">适用于以固定式低温储罐为气源设备的液氧（LO2）、液氮（LN2）、液氩（LAr）、液态二氧化碳(LCO2)、液化天然气(LNG)等介质的供气系统。</div>
              <div className="hardwaretwo-content-item-textitle">产品参数</div>
              <div className="hardwaretwo-content-item-table">
                <div className="hardwaretwo-content-item-table-th">
                  <div className="hardwaretwo-content-item-table-th-item">供应电压</div>
                  <div className="hardwaretwo-content-item-table-th-item">触摸屏尺寸</div>
                  <div className="hardwaretwo-content-item-table-th-item">压力监测通道</div>
                  <div className="hardwaretwo-content-item-table-th-item">流量监测通道</div>
                  <div className="hardwaretwo-content-item-table-th-item">气体名称/标识色</div>
                  <div className="hardwaretwo-content-item-table-th-item">气体压力单位</div>
                  <div className="hardwaretwo-content-item-table-th-item">通讯方式</div>
                  <div className="hardwaretwo-content-item-table-th-item">输入方式</div>
                  <div className="hardwaretwo-content-item-table-th-item">输出方式</div>
                  <div className="hardwaretwo-content-item-table-th-item">远程监控</div>
                  <div className="hardwaretwo-content-item-table-th-item">联动报警</div>
                  <div className="hardwaretwo-content-item-table-th-item">安装方式</div>
                </div>
                <div className="hardwaretwo-content-item-table-td">
                  <div className="hardwaretwo-content-item-table-td-item">标准24VDC</div>
                  <div className="hardwaretwo-content-item-table-td-item">15.6寸</div>
                  <div className="hardwaretwo-content-item-table-td-item">1~6路</div>
                  <div className="hardwaretwo-content-item-table-td-item">1~6路</div>
                  <div className="hardwaretwo-content-item-table-td-item">自定义编辑设置</div>
                  <div className="hardwaretwo-content-item-table-td-item">KPa、MPa.Psi.Bar</div>
                  <div className="hardwaretwo-content-item-table-td-item">以太网、4G、LORA</div>
                  <div className="hardwaretwo-content-item-table-td-item">4-20mA. RS485</div>
                  <div className="hardwaretwo-content-item-table-td-item">RS485</div>
                  <div className="hardwaretwo-content-item-table-td-item">支持PC端、移动端远程监控</div>
                  <div className="hardwaretwo-content-item-table-td-item">支持</div>
                  <div className="hardwaretwo-content-item-table-td-item">壁挂式、嵌入式</div>
                </div>
              </div>
            </div>
          </div>
        )}
        {id == 5 && (
          <div className="hardwaretwo-content">
            <div className="hardwaretwo-content-item">
              <div className="hardwaretwo-content-item-imgbox">
                <img className="hardwaretwo-content-item-img" style={{ width: '10rem' }} src={require('../../../image/t3.png')} />
              </div>

              <div className="hardwaretwo-content-item-title">获取完整产品规格书</div>
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的姓名" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的公司" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的电话" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的邮箱" />
              <button className="hardwaretwo-content-item-button">立即获取</button>
            </div>
            <div className="hardwaretwo-content-item">
              <div className="hardwaretwo-content-item-h1">壁挂式温湿度变送器</div>
              <div className="hardwaretwo-content-item-textitle">产品概述</div>
              <div className="hardwaretwo-content-item-textcontent">数显温湿度变送器采用瑞士进口数字式温湿度传感器，生产时已经过精细的标定，标定数据存储在内部存储器中。温湿度传感器具有数字式输出，可完全互转的特点，不需要经过复杂的校验，标定过程，测量精度、线性度、重复性、互转性、一致性等方面出类拔萃，它适用于环境设备配套，仪器设备集成，大量的一般性环境测验。</div>
              <div className="hardwaretwo-content-item-textitle">产品特点</div>
              <div className="hardwaretwo-content-item-textcontent">
                • 数字线性化修正，高精度、高稳定
                <br />
                • 温度测量范围宽，测量范围可选
                <br />
                • 体积小、重量轻、抗震动，安装灵活，使用方便
                <br />
                • 可做成分体式按照，方便不同客户的需求
                <br />
                • 抗干扰电路设计，适用环境广泛
                <br />• 性价比超高，宽电压设计
              </div>
              <div className="hardwaretwo-content-item-textitle">适用场合</div>
              <div className="hardwaretwo-content-item-textcontent">广泛应用于楼宇自控、工控机房、造纸、仓储物流、商场、宾馆、电影院、火车站、博物馆、影剧院、农业大棚、医院、气象、洁净车间等需要测量空气温度的领域。</div>
              <div className="hardwaretwo-content-item-textitle">产品参数</div>
              <div className="hardwaretwo-content-item-table">
                <div className="hardwaretwo-content-item-table-th">
                  <div className="hardwaretwo-content-item-table-th-item">测量介质</div>
                  <div className="hardwaretwo-content-item-table-th-item">温度范围</div>
                  <div className="hardwaretwo-content-item-table-th-item">湿度范围</div>
                  <div className="hardwaretwo-content-item-table-th-item">温度精度</div>
                  <div className="hardwaretwo-content-item-table-th-item">湿度精度</div>
                  <div className="hardwaretwo-content-item-table-th-item">长期稳定性</div>
                  <div className="hardwaretwo-content-item-table-th-item">过载能力</div>
                  <div className="hardwaretwo-content-item-table-th-item">显示方式</div>
                  <div className="hardwaretwo-content-item-table-th-item">通讯协议</div>
                  <div className="hardwaretwo-content-item-table-th-item">开关量输出</div>
                  <div className="hardwaretwo-content-item-table-th-item">供电</div>
                  <div className="hardwaretwo-content-item-table-th-item">安装方式</div>
                  <div className="hardwaretwo-content-item-table-th-item">外形尺寸</div>
                  <div className="hardwaretwo-content-item-table-th-item">材质</div>
                  <div className="hardwaretwo-content-item-table-th-item">防护等级</div>
                </div>

                <div className="hardwaretwo-content-item-table-td">
                  <div className="hardwaretwo-content-item-table-td-item">气体</div>
                  <div className="hardwaretwo-content-item-table-td-item">-20~100℃</div>
                  <div className="hardwaretwo-content-item-table-td-item">0-100%RH</div>
                  <div className="hardwaretwo-content-item-table-td-item">±0.5%</div>
                  <div className="hardwaretwo-content-item-table-td-item">±3%</div>
                  <div className="hardwaretwo-content-item-table-td-item">量程1-2倍</div>
                  <div className="hardwaretwo-content-item-table-td-item">小于0.1%FS/年，小于0.2%FS/年</div>
                  <div className="hardwaretwo-content-item-table-td-item">LCD液晶显示</div>
                  <div className="hardwaretwo-content-item-table-td-item">RS485 RTU</div>
                  <div className="hardwaretwo-content-item-table-td-item">2个上下限报警(备选)</div>
                  <div className="hardwaretwo-content-item-table-td-item">12~24V DC</div>
                  <div className="hardwaretwo-content-item-table-td-item">壁挂式</div>
                  <div className="hardwaretwo-content-item-table-td-item">95*95*30mm</div>
                  <div className="hardwaretwo-content-item-table-td-item">ABS阻燃</div>
                  <div className="hardwaretwo-content-item-table-td-item">IP65</div>
                </div>
              </div>
            </div>
          </div>
        )}
        {id == 6 && (
          <div className="hardwaretwo-content">
            <div className="hardwaretwo-content-item">
              <div className="hardwaretwo-content-item-imgbox">
                <img className="hardwaretwo-content-item-img" src={require('../../../image/t1.png')} />
              </div>

              <div className="hardwaretwo-content-item-title">获取完整产品规格书</div>
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的姓名" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的公司" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的电话" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的邮箱" />
              <button className="hardwaretwo-content-item-button">立即获取</button>
            </div>
            <div className="hardwaretwo-content-item">
              <div className="hardwaretwo-content-item-h1">高温温湿度</div>
              <div className="hardwaretwo-content-item-textitle">产品概述</div>
              <div className="hardwaretwo-content-item-textcontent">高温温度变送器采用瑞士电容式湿度传感器，生产时已经过精细的标定，标定数据存储在内部存储器中。温湿度传感器具有数字式输出，可完全互转的特点，不需要经过复杂的校验，标定过程，测量精度、线性度、重复性、互转性、一致性等方面出类拔萃，它适用于环境设备配套，仪器设备集成，大量的一般性环境测验。</div>
              <div className="hardwaretwo-content-item-textitle">产品特点</div>
              <div className="hardwaretwo-content-item-textcontent">
                • 新型铸铝外壳，耐震抗干扰强。 <br />
                • 数字线性化修正，高精度、高稳定。 <br />
                • 温度测量范围宽，测量范围可选。 <br />
                • 体积小、重量轻、抗震动，安装灵活,使用方便。 <br />
                • 可做成多种外形，方便不同客户的需求。 <br />
              </div>
              <div className="hardwaretwo-content-item-textitle">适用场合</div>
              <div className="hardwaretwo-content-item-textcontent">广泛应用于烟气脱硫、脱硝，高温烘箱、木材烘干、食品烘干、药材烘干等需要测量空气高温湿度的领域。</div>
              <div className="hardwaretwo-content-item-textitle">产品参数</div>
              <div className="hardwaretwo-content-item-textcontent1">
                1、本产品是非防爆类型,如需要防爆型产品请在订货时说明 <br />
                2、本产品为非抗结露型产品,不能长期工作结露的环境中，如果需要在凝露的环境中使用， 请在订货时说明 <br />
                3、传感器探头垂直向下安装时,测量精度最佳 <br />
                4、传感器探头严禁浸水、淋水使用 <br />
                5、探头部分的湿敏芯片严禁用手或者其它物体触摸和硬物刮伤,也不能用酒精等有机溶剂清洗，如果需要清洗，请寄我回我公司处理 <br />
                6、探头保护罩是不锈钢粉末烧结而成(孔径10微米)，长时间使用在粉尘环境中导致通气性变差，影响测量精度和响应速度。当传感器响应速度变慢时，可以在断开传感器电源的条件下将保护罩沿反时针方向旋转直至与传感器分离，然后用洗洁剂反复清洗，并用热风由里向外烘开后安装使用。在清洗时，除保护罩外，洗洁剂不能接触传感器任何地方，特别是电路芯片，否则将造成电路损坏。强酸强碱类型的洗洁剂会损坏保护罩。
              </div>
            </div>
          </div>
        )}
        {id == 7 && (
          <div className="hardwaretwo-content">
            <div className="hardwaretwo-content-item">
              <div className="hardwaretwo-content-item-imgbox">
                <img className="hardwaretwo-content-item-img" src={require('../../../image/低温储蓄罐1.png')} />
              </div>

              <div className="hardwaretwo-content-item-title">获取完整产品规格书</div>
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的姓名" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的公司" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的电话" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的邮箱" />
              <button className="hardwaretwo-content-item-button">立即获取</button>
            </div>
            <div className="hardwaretwo-content-item">
              <div className="hardwaretwo-content-item-h1">低温储罐运行监测仪</div>
              <div className="hardwaretwo-content-item-textitle">产品概述</div>
              <div className="hardwaretwo-content-item-textcontent">储罐/罐箱/槽车/迷你罐用差压式监测仪——适用于旧罐改造液位计安装，电池供电，手机、电脑可监测，可定位，实现远程监测液位、压力、位置信息实时发送数据。</div>
              <div className="hardwaretwo-content-item-textitle">产品特点</div>
              <div className="hardwaretwo-content-item-textcontent">
                • 集成高精度液位、压力、温度检测 <br />
                • 多介质检测切换 <br />
                • IP67高等级防护结构 <br />
                • 防爆一体化设计壳体 <br />
                • 支持多种数据输出方式 <br />• 自定义液晶显示数据类别
              </div>
              <div className="hardwaretwo-content-item-textitle">适用场合</div>
              <div className="hardwaretwo-content-item-textcontent">广泛应用于楼宇自控、工控机房、造纸、仓储物流、商场、宾馆、电影院、火车站、博物馆、影剧院、农业大棚、医院、气象、洁净车间等需要测量空气温度的领域。</div>
              <div className="hardwaretwo-content-item-textitle">产品参数</div>
              <div className="hardwaretwo-content-item-table">
                <div className="hardwaretwo-content-item-table-th">
                  <div className="hardwaretwo-content-item-table-th-item">测量介质</div>
                  <div className="hardwaretwo-content-item-table-th-item" style={{ borderBottom: '1px solid white' }}></div>
                  <div className="hardwaretwo-content-item-table-th-item" style={{ borderBottom: '1px solid white' }}>
                    温度范围
                  </div>
                  <div className="hardwaretwo-content-item-table-th-item"></div>
                  <div className="hardwaretwo-content-item-table-th-item" style={{ borderBottom: '1px solid white' }}></div>
                  <div className="hardwaretwo-content-item-table-th-item" style={{ borderBottom: '1px solid white' }}>
                    测量精度
                  </div>
                  <div className="hardwaretwo-content-item-table-th-item"></div>
                  <div className="hardwaretwo-content-item-table-th-item">定位方式</div>
                  <div className="hardwaretwo-content-item-table-th-item" style={{ borderBottom: '1px solid white' }}></div>
                  <div className="hardwaretwo-content-item-table-th-item" style={{ borderBottom: '1px solid white' }}>
                    显示单位
                  </div>
                  <div className="hardwaretwo-content-item-table-th-item"></div>
                  <div className="hardwaretwo-content-item-table-th-item">输出方式</div>
                  <div className="hardwaretwo-content-item-table-th-item">供电电压</div>
                  <div className="hardwaretwo-content-item-table-th-item">产品材质</div>
                  <div className="hardwaretwo-content-item-table-th-item">防爆等级</div>
                  <div className="hardwaretwo-content-item-table-th-item">机械保护</div>
                </div>

                <div className="hardwaretwo-content-item-table-td">
                  <div className="hardwaretwo-content-item-table-td-item">LNG/L02/LN2/CO2/LAr/N20</div>
                  <div className="hardwaretwo-content-item-table-td-item">差压量程：0-50KPa、0-150KPa</div>
                  <div className="hardwaretwo-content-item-table-td-item">压力量程：0-4MPa</div>
                  <div className="hardwaretwo-content-item-table-td-item">温度量程：-200-+100°C</div>
                  <div className="hardwaretwo-content-item-table-td-item">差压量程：0-50KPa、0-150KPa</div>
                  <div className="hardwaretwo-content-item-table-td-item">压力量程：0-4MPa</div>
                  <div className="hardwaretwo-content-item-table-td-item">温度量程：-200-+100°C</div>
                  <div className="hardwaretwo-content-item-table-td-item">BD. GPS</div>
                  <div className="hardwaretwo-content-item-table-td-item">液位：％、KG、T、m3</div>
                  <div className="hardwaretwo-content-item-table-td-item">压力：KPa、MPa</div>
                  <div className="hardwaretwo-content-item-table-td-item">温度：°C</div>
                  <div className="hardwaretwo-content-item-table-td-item">R$485. 4G. LORA, NB-LOT, ZigBee</div>
                  <div className="hardwaretwo-content-item-table-td-item">标准24VDC或3.6V锂电池</div>
                  <div className="hardwaretwo-content-item-table-td-item">铸铝合金+304不锈钢</div>
                  <div className="hardwaretwo-content-item-table-td-item">IP67</div>
                  <div className="hardwaretwo-content-item-table-td-item">Exia Il BT4</div>
                </div>
              </div>
            </div>
          </div>
        )}
        {id == 8 && (
          <div className="hardwaretwo-content">
            <div className="hardwaretwo-content-item">
              <div className="hardwaretwo-content-item-imgbox">
                <img className="hardwaretwo-content-item-img" style={{ width: '7rem' }} src={require('../../../image/t2.png')} />
              </div>

              <div className="hardwaretwo-content-item-title">获取完整产品规格书</div>
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的姓名" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的公司" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的电话" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的邮箱" />
              <button className="hardwaretwo-content-item-button">立即获取</button>
            </div>
            <div className="hardwaretwo-content-item">
              <div className="hardwaretwo-content-item-h1">风道式温湿度传感器</div>
              <div className="hardwaretwo-content-item-textitle">产品概述</div>
              <div className="hardwaretwo-content-item-textcontent">瑞士电容式湿度传感器，数字式输出可完全互转，一致性等方面出类拔萃。新型铸铝外壳，耐震抗干扰强，生产时已经过精细的标定，标定数据存储在内部存储器中。温湿度传感器具有数字式输出，可完全互转的特点，不需要经过复杂的校验，标定过程，测量精度、线性度、重复性、互转性、一致性等方面出类拔萃， 它适用于环境设备配套，仪器设备集成，大量的一般性环境测验。</div>
              <div className="hardwaretwo-content-item-textitle">产品特点</div>
              <div className="hardwaretwo-content-item-textcontent">
                • 数字线性化修正,高精度、高稳定 <br />
                • 温度测量范围宽，测量范围可选 <br />
                • 体积小、重量轻、抗震动,安装灵活，使用方便 <br />
                • 可做成分体式按照,方便不同客户的需求 <br />• 抗干扰电路设计，适用环境广泛
              </div>
              <div className="hardwaretwo-content-item-textitle">适用场合</div>
              <div className="hardwaretwo-content-item-textcontent">广泛应用于楼宇自控、工控机房、造纸、仓储物流、商场、宾馆、电影院、火车站、博物馆、影剧院、农业大棚、医院、气象、洁净车间等需要测量空气温度的领域。</div>
              <div className="hardwaretwo-content-item-textitle">产品参数</div>
              <div className="hardwaretwo-content-item-table">
                <div className="hardwaretwo-content-item-table-th">
                  <div className="hardwaretwo-content-item-table-th-item">测量介质</div>
                  <div className="hardwaretwo-content-item-table-th-item">温度范围</div>
                  <div className="hardwaretwo-content-item-table-th-item">湿度范围</div>
                  <div className="hardwaretwo-content-item-table-th-item">温度精度</div>
                  <div className="hardwaretwo-content-item-table-th-item">湿度精度</div>
                  <div className="hardwaretwo-content-item-table-th-item">长期稳定性</div>
                  <div className="hardwaretwo-content-item-table-th-item">过载能力</div>
                  <div className="hardwaretwo-content-item-table-th-item">显示方式</div>
                  <div className="hardwaretwo-content-item-table-th-item">通讯协议</div>
                  <div className="hardwaretwo-content-item-table-th-item">供电</div>
                  <div className="hardwaretwo-content-item-table-th-item">安装方式</div>
                  <div className="hardwaretwo-content-item-table-th-item">材质</div>
                  <div className="hardwaretwo-content-item-table-th-item">防护等级</div>
                </div>
                <div className="hardwaretwo-content-item-table-td">
                  <div className="hardwaretwo-content-item-table-td-item">气体</div>
                  <div className="hardwaretwo-content-item-table-td-item">-40~120℃</div>
                  <div className="hardwaretwo-content-item-table-td-item">0-100%RH</div>
                  <div className="hardwaretwo-content-item-table-td-item">±0.5%</div>
                  <div className="hardwaretwo-content-item-table-td-item">±2%</div>
                  <div className="hardwaretwo-content-item-table-td-item">量程1-2倍</div>
                  <div className="hardwaretwo-content-item-table-td-item">小于0.1%FS/年，小于0.2%FS/年</div>
                  <div className="hardwaretwo-content-item-table-td-item">LCD液晶显示</div>
                  <div className="hardwaretwo-content-item-table-td-item">RS485 RTU/4-20mA</div>
                  <div className="hardwaretwo-content-item-table-td-item">12~24V DC</div>
                  <div className="hardwaretwo-content-item-table-td-item">管道式</div>
                  <div className="hardwaretwo-content-item-table-td-item">铸铝外壳</div>
                  <div className="hardwaretwo-content-item-table-td-item">IP65</div>
                </div>
              </div>
            </div>
          </div>
        )}
        {id == 9 && (
          <div className="hardwaretwo-content">
            <div className="hardwaretwo-content-item">
              <div className="hardwaretwo-content-item-imgbox">
                <img className="hardwaretwo-content-item-img" src={require('../../../image/通用型.png')} />
              </div>

              <div className="hardwaretwo-content-item-title">获取完整产品规格书</div>
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的姓名" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的公司" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的电话" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的邮箱" />
              <button className="hardwaretwo-content-item-button">立即获取</button>
            </div>
            <div className="hardwaretwo-content-item">
              <div className="hardwaretwo-content-item-h1">通用型压力变送器</div>
              <div className="hardwaretwo-content-item-textitle">产品概述</div>
              <div className="hardwaretwo-content-item-textcontent">通用型压力变送器选用进口传感器压力敏感元件，采用计算机激光调阻进行温度补偿。一体化的接线盒设计。具有专用接线端子以及指针或数字显示，安装、校验、维修方便等特点。</div>
              <div className="hardwaretwo-content-item-textitle">产品特点</div>
              <div className="hardwaretwo-content-item-textcontent">
                • 采用膜片隔离防腐设计
                <br />
                • 集成芯片、宽电压供电
                <br />
                • 抗射频干扰能力强
                <br />
                • 结构小巧、安装方便
                <br />
                • 激光调阻温度补偿
                <br />• 抗击、耐振动防护
              </div>
              <div className="hardwaretwo-content-item-textitle">适用场合</div>
              <div className="hardwaretwo-content-item-textcontent">适用于石油、水利、化工、冶金、电力、轻工、科研、环保等行业，各种场合全天候环境及各种腐蚀性流体压力的测量。 </div>
              <div className="hardwaretwo-content-item-textitle">产品参数</div>
              <div className="hardwaretwo-content-item-table">
                <div className="hardwaretwo-content-item-table-th">
                  <div className="hardwaretwo-content-item-table-th-item">测量介质</div>
                  <div className="hardwaretwo-content-item-table-th-item">测量范围</div>
                  <div className="hardwaretwo-content-item-table-th-item">测量精度</div>
                  <div className="hardwaretwo-content-item-table-th-item">过载能力</div>
                  <div className="hardwaretwo-content-item-table-th-item">稳定性能</div>
                  <div className="hardwaretwo-content-item-table-th-item">输出方式</div>
                  <div className="hardwaretwo-content-item-table-th-item">安装方式</div>
                  <div className="hardwaretwo-content-item-table-th-item">供电电压</div>
                  <div className="hardwaretwo-content-item-table-th-item" style={{ borderBottom: '1px solid white' }}></div>
                  <div className="hardwaretwo-content-item-table-th-item" style={{ borderBottom: '1px solid white' }}></div>
                  <div className="hardwaretwo-content-item-table-th-item" style={{ borderBottom: '1px solid white' }}>
                    产品材质
                  </div>
                  <div className="hardwaretwo-content-item-table-th-item" style={{ borderBottom: '1px solid white' }}></div>
                  <div className="hardwaretwo-content-item-table-th-item"></div>

                  <div className="hardwaretwo-content-item-table-th-item">防护等级</div>
                </div>

                <div className="hardwaretwo-content-item-table-td">
                  <div className="hardwaretwo-content-item-table-td-item"> 液体或气体（与接触材质兼容）</div>
                  <div className="hardwaretwo-content-item-table-td-item">0~25MPa /0~100KPa /0~1600KPa</div>
                  <div className="hardwaretwo-content-item-table-td-item">0.5% F.S</div>
                  <div className="hardwaretwo-content-item-table-td-item">150%满量程</div>
                  <div className="hardwaretwo-content-item-table-td-item">士0.25%FS/年</div>
                  <div className="hardwaretwo-content-item-table-td-item">4~20mA、RS485</div>
                  <div className="hardwaretwo-content-item-table-td-item">螺纹连接</div>
                  <div className="hardwaretwo-content-item-table-td-item">15~30VDC,标准24VDC</div>
                  <div className="hardwaretwo-content-item-table-td-item">膜片：316不锈钢（接触）</div>
                  <div className="hardwaretwo-content-item-table-td-item">过程连接：304不锈钢（接触）</div>
                  <div className="hardwaretwo-content-item-table-td-item">密封件：丁睛橡胶（接触）</div>
                  <div className="hardwaretwo-content-item-table-td-item">外壳：304不锈钢</div>
                  <div className="hardwaretwo-content-item-table-td-item">赫斯曼接头：ABS工程塑料</div>
                  <div className="hardwaretwo-content-item-table-td-item">IP65</div>
                </div>
              </div>
            </div>
          </div>
        )}
        {id == 10 && (
          <div className="hardwaretwo-content">
            <div className="hardwaretwo-content-item">
              <div className="hardwaretwo-content-item-imgbox">
                <img className="hardwaretwo-content-item-img" src={require('../../../image/防爆型.png')} />
              </div>

              <div className="hardwaretwo-content-item-title">获取完整产品规格书</div>
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的姓名" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的公司" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的电话" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的邮箱" />
              <button className="hardwaretwo-content-item-button">立即获取</button>
            </div>
            <div className="hardwaretwo-content-item">
              <div className="hardwaretwo-content-item-h1">防爆型压力变送器</div>
              <div className="hardwaretwo-content-item-textitle">产品概述</div>
              <div className="hardwaretwo-content-item-textcontent">防爆型压力变送器选用进口传感器压力敏感元件，采用计算机激光调阻进行温度补偿。一体化的接线盒设计。具有专用接线端子以及指针或数字显示，安装、校验、维修方便等特点。</div>
              <div className="hardwaretwo-content-item-textitle">产品特点</div>
              <div className="hardwaretwo-content-item-textcontent">
                • 采用膜片隔离防腐设计 <br />
                • 集成芯片、宽电压供电 <br />
                • 抗射频干扰能力强 <br />
                • 结构小巧、安装方便 <br />
                • 激光调阻温度补偿 <br />
                • 抗击、耐振动防护 <br />• 隔爆型，不锈钢防爆壳体
              </div>
              <div className="hardwaretwo-content-item-textitle">适用场合</div>
              <div className="hardwaretwo-content-item-textcontent">适用于石油、水利、化工、冶金、电力、轻工、科研、环保等行业，各种场合全天候环境及各种腐蚀性流体压力的测量。 </div>
              <div className="hardwaretwo-content-item-textitle">产品参数</div>
              <div className="hardwaretwo-content-item-table">
                <div className="hardwaretwo-content-item-table-th">
                  <div className="hardwaretwo-content-item-table-th-item">测量介质</div>
                  <div className="hardwaretwo-content-item-table-th-item">测量范围</div>
                  <div className="hardwaretwo-content-item-table-th-item">测量精度</div>
                  <div className="hardwaretwo-content-item-table-th-item">过载能力</div>
                  <div className="hardwaretwo-content-item-table-th-item">稳定性能</div>
                  <div className="hardwaretwo-content-item-table-th-item">输出方式</div>
                  <div className="hardwaretwo-content-item-table-th-item">安装方式</div>
                  <div className="hardwaretwo-content-item-table-th-item">供电电压</div>
                  <div className="hardwaretwo-content-item-table-th-item" style={{ borderBottom: '1px solid white' }}></div>
                  <div className="hardwaretwo-content-item-table-th-item" style={{ borderBottom: '1px solid white' }}>
                    产品材质
                  </div>
                  <div className="hardwaretwo-content-item-table-th-item"></div>

                  <div className="hardwaretwo-content-item-table-th-item">防护等级</div>
                  <div className="hardwaretwo-content-item-table-th-item">防爆等级</div>
                </div>

                <div className="hardwaretwo-content-item-table-td">
                  <div className="hardwaretwo-content-item-table-td-item"> 液体或气体（与接触材质兼容）</div>
                  <div className="hardwaretwo-content-item-table-td-item">0~25MPa /0~100KPa /0~1600KPa</div>
                  <div className="hardwaretwo-content-item-table-td-item">0.5% F.S</div>
                  <div className="hardwaretwo-content-item-table-td-item">150%满量程</div>
                  <div className="hardwaretwo-content-item-table-td-item">士0.25%FS/年</div>
                  <div className="hardwaretwo-content-item-table-td-item">4~20mA、RS485</div>
                  <div className="hardwaretwo-content-item-table-td-item">螺纹连接</div>
                  <div className="hardwaretwo-content-item-table-td-item">15~30VDC,标准24VDC</div>
                  <div className="hardwaretwo-content-item-table-td-item">膜片：316不锈钢（接触）</div>
                  <div className="hardwaretwo-content-item-table-td-item">过程连接：304不锈钢（接触）</div>
                  <div className="hardwaretwo-content-item-table-td-item">密封件：丁腈橡胶（接触） 外壳：304不锈钢</div>
                  <div className="hardwaretwo-content-item-table-td-item">IP65</div>
                  <div className="hardwaretwo-content-item-table-td-item">EXIA Il CT5</div>
                </div>
              </div>
            </div>
          </div>
        )}
        {id == 11 && (
          <div className="hardwaretwo-content">
            <div className="hardwaretwo-content-item">
              <div className="hardwaretwo-content-item-imgbox">
                <img className="hardwaretwo-content-item-img" src={require('../../../image/气体汇流排运行监测箱.png')} />
              </div>

              <div className="hardwaretwo-content-item-title">获取完整产品规格书</div>
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的姓名" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的公司" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的电话" />
              <input className="hardwaretwo-content-item-input" placeholder="请输入您的邮箱" />
              <button className="hardwaretwo-content-item-button">立即获取</button>
            </div>
            <div className="hardwaretwo-content-item">
              <div className="hardwaretwo-content-item-h1">气体汇流排运行监测箱</div>
              <div className="hardwaretwo-content-item-textitle">产品概述</div>
              <div className="hardwaretwo-content-item-textcontent">该设备通过底层传感器所采集压力数据，可实时监测气体汇流排在用侧、备用侧、管路输出压力，具有数据本地显示和异常报警功能，通过预留的数字通讯传输接口和内置通讯模块，可实现远程监测和手 机端监测。</div>
              <div className="hardwaretwo-content-item-textitle">产品特点</div>
              <div className="hardwaretwo-content-item-textcontent">
                • 适用性强，可适用手动/自动气体汇流排 <br />
                • 安装调试简单，美观使用 <br />
                • 电子数显屏，数据直观清晰 <br />• 在用/备用状态直观显示
              </div>
              <div className="hardwaretwo-content-item-textitle">适用场合</div>
              <div className="hardwaretwo-content-item-textcontent">适用于监测各类手动/自动气体汇流排设备的运行状态。 </div>
              <div className="hardwaretwo-content-item-textitle">产品参数</div>

              <div className="hardwaretwo-content-item-table">
                <div className="hardwaretwo-content-item-table-th">
                  <div className="hardwaretwo-content-item-table-th-item">箱体供电</div>
                  <div className="hardwaretwo-content-item-table-th-item">显示方式</div>
                  <div className="hardwaretwo-content-item-table-th-item">输入压力范围</div>
                  <div className="hardwaretwo-content-item-table-th-item">输出压力范围</div>
                  <div className="hardwaretwo-content-item-table-th-item">输入方式</div>
                  <div className="hardwaretwo-content-item-table-th-item">输出方式</div>
                  <div className="hardwaretwo-content-item-table-th-item">各排运行状态</div>
                  <div className="hardwaretwo-content-item-table-th-item">产品尺寸</div>
                </div>

                <div className="hardwaretwo-content-item-table-td">
                  <div className="hardwaretwo-content-item-table-td-item">24VDC </div>
                  <div className="hardwaretwo-content-item-table-td-item">电子数显屏 </div>
                  <div className="hardwaretwo-content-item-table-td-item">0~25MPa, 0~40MPa </div>
                  <div className="hardwaretwo-content-item-table-td-item"> 0~1.6MPa</div>
                  <div className="hardwaretwo-content-item-table-td-item">RS-485/4-20mA</div>
                  <div className="hardwaretwo-content-item-table-td-item">RS-485、用子远程通信</div>
                  <div className="hardwaretwo-content-item-table-td-item">自动采集/手动切换</div>
                  <div className="hardwaretwo-content-item-table-td-item">400 mm X300mm X150mm</div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  )
}
